import ElementContent from '@/components/sections/builder/elements/footer/footer/content';
import FooterSectionImage from '@/components/sections/builder/elements/footer/footer/sections/image';
import FooterSectionText from '@/components/sections/builder/elements/footer/footer/sections/text';
import FooterSectionMenu from '@/components/sections/builder/elements/footer/footer/sections/menu';
import ElementSetting from '@/components/sections/builder/elements/footer/footer/setting';
import { FooterElementDataType } from '@/components/sections/builder/elements/footer/footer/types';
import FooterSectionBrandInfo from '@/components/sections/builder/elements/footer/footer/sections/brand-info';
import FooterSectionTextWithIcon from '@/components/sections/builder/elements/footer/footer/sections/text-with-icon';
import FooterSectionSocialMedia from '@/components/sections/builder/elements/footer/footer/sections/social-media';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData: FooterElementDataType = {
  name: 'Footer',
  footerWidth: 'layout',
  alignment: 'left',
  backgroundScheme: '',
  isShowEmailSignUp: false,
  headingEmailSignUp: 'Subscribe to our emails',
  topMargin: 48,
  topPadding: 36,
  bottomPadding: 36,
  twitterUrl: '',
  facebookUrl: '',
  instagramUrl: '',
  youtubeUrl: '',
  tiktokUrl: '',
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const Footer = {
  type: 'footer_section',
  group: 'footer',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [
    FooterSectionMenu,
    FooterSectionText,
    FooterSectionImage,
    FooterSectionBrandInfo,
    FooterSectionTextWithIcon,
    FooterSectionSocialMedia,
  ],
  childs: [
    FooterSectionMenu,
    FooterSectionText,
    FooterSectionImage,
    FooterSectionBrandInfo,
    FooterSectionTextWithIcon,
    FooterSectionSocialMedia,
  ],
};

export default Footer;
